import {
  deletePnrFromDB,
  getAllpnrsFromDB,
  handleStatusUpdate,
} from "../../service/dashboard/dashBoardServicel";
import { Booking } from "../../types/types";
import axios from "axios";
import { CompletionDetails } from "./CompleteBookingModal";

const API_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

const getBookingById = async (bookingId: number | string) => {
  try {
    const response = await axios.get(`${API_URL}/pnr/${bookingId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching local booking data:", error);
    return null;
  }
};

const getAllBookings = async () => {
  const booking: Booking[] = await getAllpnrsFromDB();
  return booking;
};
const deleteBooking = async (id: number): Promise<void> => {
  try {
    await deletePnrFromDB(id);
  } catch (error) {
    throw error;
  }
};

const updateStatus = async (
  controlNumber: string,
  status: string,
): Promise<boolean> => {
  try {
    return await handleStatusUpdate(controlNumber, status);
  } catch (error) {
    return false;
  }
};

const updateBookingPnr = async (
  bookingId: number,
  newPnr: string,
): Promise<boolean> => {
  try {
    const response = await axios.put(`${API_URL}/pnr/update-pnr`, {
      bookingId,
      newPnr,
      adminId: "Admin",
    });
    return response.data.success;
  } catch (error) {
    console.error("Error updating PNR:", error);
    return false;
  }
};

const updateBookingTicketNumber = async (
  bookingId: number,
  newTicketNumber: string,
): Promise<boolean> => {
  try {
    const response = await axios.put(`${API_URL}/pnr/update-ticket-number`, {
      bookingId,
      newTicketNumber,
      adminId: "Admin",
    });
    return response.data.success;
  } catch (error) {
    console.error("Error updating Ticket Number:", error);
    return false;
  }
};

const completeBooking = async (
  controlNumber: string,
  details: CompletionDetails,
): Promise<boolean> => {
  try {
    const response = await axios.patch(
      `${API_URL}/dashboard/pnrs/completeBooking/${controlNumber}`,
      details,
    );
    // Assuming backend returns { success: true }
    return (
      response.data.success === true ||
      response.status === 200 ||
      response.status === 201
    );
  } catch (error) {
    console.error("Error completing booking:", error);
    return false;
  }
};

const updateBookingCurrency = async (
  controlNumber: string,
  currency: string,
): Promise<boolean> => {
  try {
    const response = await axios.patch(
      `${API_URL}/dashboard/pnrs/updateCurrency/${controlNumber}`,
      { currency },
    );
    return response.data; // Assuming backend returns true/false
  } catch (error) {
    console.error("Error updating currency:", error);
    return false;
  }
};

const updatePassengerTicketNumber = async (
  passengerId: number,
  newTicketNumber: string,
): Promise<boolean> => {
  try {
    const response = await axios.put(`${API_URL}/pnr/update-passenger-ticket`, {
      passengerId,
      newTicketNumber,
      adminId: "Admin",
    });
    return response.data.success;
  } catch (error) {
    console.error("Error updating Passenger Ticket Number:", error);
    return false;
  }
};

// ✅ NEW: Accept currency and send it as a query parameter
const getSupabaseDropdownOptions = async (currency: string = "EUR") => {
  try {
    const response = await axios.get(
      `${API_URL}/pnr/supabase-options?currency=${currency}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Supabase dropdown options:", error);
    return { agents: [], platforms: [], issuedFrom: [] };
  }
};

// Add these functions below your other API calls
const updatePassengerDetails = async (
  passengerId: number,
  data: any,
): Promise<boolean> => {
  try {
    const response = await axios.put(
      `${API_URL}/pnr/update-passenger-details`,
      {
        passengerId,
        data,
      },
    );
    return response.data.success;
  } catch (error) {
    console.error("Error updating passenger details:", error);
    return false;
  }
};

const updateFlightDetails = async (
  flightId: string,
  data: any,
): Promise<boolean> => {
  try {
    const response = await axios.put(`${API_URL}/pnr/update-flight-details`, {
      flightId,
      data,
    });
    return response.data.success;
  } catch (error) {
    console.error("Error updating flight details:", error);
    return false;
  }
};

const updateBookingRecord = async (
  bookingId: number,
  data: any,
): Promise<boolean> => {
  try {
    const response = await axios.put(`${API_URL}/pnr/update-booking-record`, {
      bookingId,
      data,
    });
    return response.data.success;
  } catch (error) {
    console.error("Error updating booking record:", error);
    return false;
  }
};

const updateBaggageDetails = async (
  bookingId: number,
  baggageData: any[],
): Promise<boolean> => {
  try {
    const response = await axios.put(`${API_URL}/pnr/update-baggage-details`, {
      bookingId,
      baggageData,
    });
    return response.data.success;
  } catch (error) {
    console.error("Error updating baggage details:", error);
    return false;
  }
};

const updateBookingTimer = async (
  bookingId: number,
  newTime: string,
): Promise<boolean> => {
  try {
    const response = await axios.put(`${API_URL}/pnr/update-timer`, {
      bookingId,
      newTime,
    });
    return response.data.success;
  } catch (error) {
    console.error("Error updating booking timer:", error);
    return false;
  }
};

export {
  getAllBookings,
  deleteBooking,
  updateStatus,
  updateBookingPnr,
  updateBookingTicketNumber,
  completeBooking,
  updateBookingCurrency,
  getBookingById,
  updatePassengerTicketNumber,
  getSupabaseDropdownOptions,
  updatePassengerDetails,
  updateFlightDetails,
  updateBookingRecord,
  updateBaggageDetails,
  updateBookingTimer,
};
